module.exports = __webpack_public_path__ + "static/img/confi-dso.96bd8da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confi-dso.jpg
// module id = Bb5V
// module chunks = 1